import { InterruptionType } from '../../types';

export type InterruptionListTypeStyle = {
  color: string;
  label: string;
};

const defaultStyle: InterruptionListTypeStyle = {
  color: 'var(--mui-palette-secondary-main)',
  label: 'Interruption',
};

const styleByType: Partial<Record<InterruptionType, InterruptionListTypeStyle>> = {
  [InterruptionType.TaskStatusPing]: {
    color: 'var(--mui-palette-primary-main)',
    label: 'Task ping',
  },
};

export const getInterruptionListTypeStyle = (type: InterruptionType): InterruptionListTypeStyle => {
  return styleByType[type] ?? defaultStyle;
};
